interface LayoutColumn {
  id: string
  visibility?: boolean
}

export function useColumnsLayoutComparer() {
  return hasSameColumnsLayout
}

function hasSameColumnsLayout(a: LayoutColumn[], b: LayoutColumn[]) {
  const bIds = new Set(b.map((c) => c.id))
  const bFilteredColumns = a.filter((column) => bIds.has(column.id))

  if (bFilteredColumns.length !== b.length) {
    return false
  }

  return b.every((c, index) => {
    const sourceColumn = bFilteredColumns[index]
    return sourceColumn?.id === c.id && sourceColumn?.visibility === c.visibility
  })
}
